export const WIZR_API = import.meta.env.REACT_APP_WIZR_API;
export const REACT_APP_DOMAIN_URL = import.meta.env.REACT_APP_DOMAIN_URL;
export const GIPHY_KEY = import.meta.env.REACT_APP_GIPHY_KEY?.trim();
export const LIBRARY_URL = import.meta.env.REACT_APP_LIBRARY_URL?.trim();
export const MASTERHUB_CLOUDFRONT_URL = import.meta.env.REACT_APP_MASTERHUB_CLOUDFRONT_URL?.trim();
export const CLOUDFRONT_URL = import.meta.env.REACT_APP_CLOUDFRONT_URL?.trim();
export const CHAT_CLIENT_URL = import.meta.env.REACT_APP_CHAT_CLIENT_URL?.trim();
export const CHAT_SERVER_URL = import.meta.env.REACT_APP_CHAT_SERVER_URL?.trim();
